import React from 'react';
import PropTypes from 'prop-types';
import * as style from './ArticleList.module.scss';
import BlogIcon from '../../BlogIcon';

/**
 * List with icons.
 */
const ArticleList = (props) => {
  const { listItems } = props;

  const formListItem = (listItem, index) => {
    const { simleIconListText, simpleIconListIcon } = listItem;
    const { proIcon, proText } = listItem;
    const { conIcon, conText } = listItem;

    const iconName = simpleIconListIcon || proIcon || conIcon;
    const text = simleIconListText || proText || conText;

    return (
      <li key={index}>
        <div className={style.iconCircle}>
          <BlogIcon iconName={iconName} width={14} height={14} />
        </div>
        <div>{text}</div>
      </li>
    );
  };

  return (
    <div>
      <ul className={style.list}>
        {listItems?.map((listItem, index) => formListItem(listItem, index))}
      </ul>
    </div>
  );
};

ArticleList.propTypes = {
  /** An object containing list items. */
  listItems: PropTypes.arrayOf(
    PropTypes.shape({
      simleIconListText: PropTypes.string.isRequired,
      simpleIconListIcon: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default ArticleList;
